module.exports = __webpack_public_path__ + "static/media/accountDetailsBackground.3c4d1e7b.svg";